module.exports = __webpack_public_path__ + "img/avatar.8ba639c5.svg";